import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  InputAdornment,
} from "@material-ui/core";
import { useContext } from "react";
import { useState } from "react";
import SelectErp from "../../../../components/basics/SelectErp";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import Btn from "../../../../components/buttons/Btn";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import { formatDate } from "../../../../utils/formatDate";
import { ConciliacaoBancariaContext } from "../contexts/ConciliacaoBancariaContext";
import useConciliacaoBancariaController from "../controllers/ConciliacaoBancariaController";
import ModalCategorias from "./ModalCategorias";
import AddIcon from "@material-ui/icons/Add";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ModalCadastroCliente from "../../../../patterns/modals/modalCadastroCliente/ModalCadastroCliente";
import ModalCadastroFornecedor from "../../../../patterns/modals/modalCadastroFornecedor/ModalCadastroFornecedor";

const ModalNewPaymentsReceipts = ({
  open,
  setModalOpen,
  addPayments,
  value,
  transactionDate,
  transactionMemo,
  handleNewPaymentsReceipts = () => {},
}) => {
  const {
    createBillsToReceiveOrPayments,
    handleSelectClient,
    clientGetOptionLabel,
    handleSelectSupplier,
    handleSelectedSupplier,
    handleSelectedClient,
    supplierGetOptionLabel,
  } = useConciliacaoBancariaController();

  const {
    errors,
    setErrors,
    mainClient,
    setMainClient,
    mainSupplier,
    setMainSupplier,
  } = useContext(ConciliacaoBancariaContext);

  const [openModalCateogry, setOpenModalCateogry] = useState(false);
  const [itemCategory, setItemCategory] = useState([]);
  const [historico, setHistorico] = useState(transactionMemo || "");
  const [numeroDoc, setNumeroDoc] = useState("");
  const [modalMinClienteCadastroOpen, setModalMinClienteCadastroOpen] =
    useState(false);
  const [modalMinFornecedorCadastroOpen, setModalMinFornecedorCadastroOpen] =
    useState(false);

  const [dataEmissao, setDataEmissao] = useState(
    formatDate({
      date: transactionDate ? new Date(transactionDate) : new Date(),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [dataVencimento, setDataVencimento] = useState(
    formatDate({
      date: transactionDate ? new Date(transactionDate) : new Date(),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [valorDoc] = useState(
    value ? parseFloat(Math.abs(value)).toFixed(2) : "0.00"
  );

  const [realizadoPrevisto, setRealizadoPrevisto] = useState({
    label: "Previsto",
    value: "previsto",
  });

  const listRealizadoPrevisto = [
    { label: "Realizado", value: "realizado" },
    { label: "Previsto", value: "previsto" },
  ];

  const handleClose = () => {
    setErrors({});
    setMainClient(null);
    setMainSupplier(null);
    setModalOpen(false);
  };
  const handleAddPaymentsReceipts = async () => {
    setErrors({});

    const receiver = addPayments ? mainSupplier : mainClient;

    const fields = {
      receiver,
      dataEmissao,
      dataVencimento,
      numeroDoc,
      valorDoc,
      realizadoPrevisto,
      historico,
      itemCategory,
    };

    const retorno = await createBillsToReceiveOrPayments(fields, addPayments);

    if (retorno.success) {
      const createdTypeBIll = addPayments
        ? "accountsPay"
        : "accountsReceivable";
      const newRow = retorno.data;
      newRow.typeBill = createdTypeBIll;
      newRow.typeBillID = `${createdTypeBIll}_${newRow.id}`;

      handleNewPaymentsReceipts(newRow);

      handleClose();
    }
  };

  return (
    <>
      {modalMinFornecedorCadastroOpen && (
        <ModalCadastroFornecedor
          open={modalMinFornecedorCadastroOpen}
          setOpen={setModalMinFornecedorCadastroOpen}
          functionHandleSelectSupplier={handleSelectedSupplier}
        />
      )}
      {modalMinClienteCadastroOpen && (
        <ModalCadastroCliente
          open={modalMinClienteCadastroOpen}
          setOpen={setModalMinClienteCadastroOpen}
          functionHandleSelectClient={handleSelectedClient}
        />
      )}
      {openModalCateogry && (
        <ModalCategorias
          open={openModalCateogry}
          setModalOpen={setOpenModalCateogry}
          content={itemCategory}
          setContent={setItemCategory}
          newBankMoviment={true}
        />
      )}
      <Dialog open={open} fullWidth maxWidth="md">
        <DialogTitle
          id="customized-dialog-title"
          children={
            <div>{`Novo Conta a ${addPayments ? "Pagar" : "Receber"}`}</div>
          }
        />
        <DialogContent>
          <Grid container spacing={2} style={{ marginBottom: 30 }}>
            <Grid item xs={2}>
              {addPayments ? (
                <SearchSelect
                  helperText={errors.receiver}
                  error={errors.receiver ? true : false}
                  descriptionField="razao"
                  variant="filled"
                  value={mainSupplier}
                  setValue={handleSelectSupplier}
                  label="Fornecedor"
                  getOptionLabel={supplierGetOptionLabel}
                  where={{ ativo: "S" }}
                  route="prouser/fornecedores/v1"
                  filter="id,razao,apelido,cgc"
                  fields={{ "prouser.fornecedores": "id,razao,apelido,cgc" }}
                />
              ) : (
                <SearchSelect
                  helperText={errors.receiver}
                  error={errors.receiver ? true : false}
                  descriptionField="razao"
                  variant="filled"
                  value={mainClient}
                  setValue={handleSelectClient}
                  label="Cliente"
                  getOptionLabel={clientGetOptionLabel}
                  where={{ ativo: "S" }}
                  route="prouser/clientes/v1"
                  filter="id,razao,apelido,cpfcnpj"
                  fields={{ "prouser.clientes": "id,razao,apelido,cpfcnpj" }}
                />
              )}
            </Grid>
            <Grid item md={1}>
              <Btn
                bgcolor="lightgreen"
                hovercolor="blue"
                startIcon={<AddIcon />}
                label={<AccountCircleIcon />}
                full="true"
                onClick={() =>
                  addPayments
                    ? setModalMinFornecedorCadastroOpen(true)
                    : setModalMinClienteCadastroOpen(true)
                }
              />
            </Grid>
            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.dataEmissao}
                error={errors.dataEmissao ? true : false}
                label="Data de Emissão*"
                type="date"
                value={dataEmissao}
                setValue={setDataEmissao}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.dataVencimento}
                error={errors.dataVencimento ? true : false}
                label="Data de Vencimento*"
                type="date"
                value={dataVencimento}
                setValue={setDataVencimento}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.numeroDoc}
                error={errors.numeroDoc ? true : false}
                label="N° Documento*"
                value={numeroDoc}
                setValue={setNumeroDoc}
                maxLength={16}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 30 }}>
            <Grid item md={3}>
              <TextFieldErp
                helperText={errors.valorDoc}
                error={errors.valorDoc ? true : false}
                label="Valor*"
                value={valorDoc}
                mask="decimal"
                startAdornment={
                  <InputAdornment position="start">R$</InputAdornment>
                }
                disabled
              />
            </Grid>
            <Grid item md={3}>
              <SelectErp
                helperText={errors.realizadoPrevisto}
                error={errors.realizadoPrevisto ? true : false}
                label="Realizado/Previsto*"
                value={realizadoPrevisto}
                setValue={setRealizadoPrevisto}
                optionsList={listRealizadoPrevisto}
                descriptionField="label"
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 30 }}>
            <Grid item md={12}>
              <Grid item md={12}>
                <TextFieldErp
                  label="Histórico"
                  value={historico}
                  setValue={setHistorico}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2} style={{ marginBottom: 10 }}>
            <Grid
              item
              md={4}
              style={{ display: "flex" }}
              justifyContent={"flex-start"}
              alignItems={"flex-end"}
            >
              <Btn
                onClick={() => {
                  setOpenModalCateogry(true);
                }}
                bgcolor="primary"
                hovercolor="orange"
                label={`${
                  itemCategory.length ? "Editar" : "Adicionar"
                } Categorias`}
                fontSize={"12px"}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Btn onClick={handleAddPaymentsReceipts} label="Adicionar" />
          <Btn onClick={handleClose} bgcolor="tertiary" label="Fechar" />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ModalNewPaymentsReceipts;
